import configureStore, { history } from 'common/tools/configure-store';
import reducer from 'client/reducers';

export { history };

const preState = window.__PRELOADED_STATE__ || {};
export default configureStore(preState, reducer);
